/* (c) Quick Pro USA (quickprousa.com) - proprietary theme code. All rights reserved. */
/* qp-fr-compare.js — tab / toggle / door controller for sections/qp-fr-compare.liquid.
   Doors are any <a data-qp-compare-key="…"> in the document; "#compare-<key>" deep-links. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
    return;
  }
  root.QpFrCompare = api;
  if (root.document.readyState === 'loading') {
    root.document.addEventListener('DOMContentLoaded', function () { api.autoInit(root.document, root); });
  } else {
    api.autoInit(root.document, root);
  }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  function list(nodes) { return Array.prototype.slice.call(nodes); }

  function init(band, win) {
    if (!band) return null;
    if (band.__qpFrCompare) return band.__qpFrCompare;

    var tabs = list(band.querySelectorAll('[data-qp-compare-tab]'));
    var panels = list(band.querySelectorAll('[data-qp-compare-panel]'));
    var headings = list(band.querySelectorAll('[data-qp-compare-heading]'));
    var stage = band.querySelector('[data-qp-compare-stage]');
    var toggle = band.querySelector('[data-qp-compare-toggle]');
    if (!panels.length || !stage || !toggle) return null;

    var keys = panels.map(function (p) { return p.getAttribute('data-qp-compare-panel'); });
    var active = keys[0];

    function has(key) { return keys.indexOf(key) !== -1; }

    function select(key) {
      if (!has(key)) return false;
      active = key;
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-qp-compare-tab') === key;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-qp-compare-panel') !== key; });
      headings.forEach(function (h) { h.hidden = h.getAttribute('data-qp-compare-heading') !== key; });
      return true;
    }

    function setOpen(open) {
      stage.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      band.setAttribute('data-open', open ? 'true' : 'false');
    }

    function isOpen() { return !stage.hidden; }

    function reveal(key) {
      if (!select(key)) return false;
      setOpen(true);
      if (typeof band.scrollIntoView === 'function') {
        var reduced = !!(win && win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches);
        band.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      }
      return true;
    }

    toggle.addEventListener('click', function () { setOpen(!isOpen()); });

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab.getAttribute('data-qp-compare-tab')); });
      tab.addEventListener('keydown', function (e) {
        var next = -1;
        if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next === -1) return;
        e.preventDefault();
        select(tabs[next].getAttribute('data-qp-compare-tab'));
        tabs[next].focus();
      });
    });

    var ctl = {
      has: has,
      select: select,
      setOpen: setOpen,
      isOpen: isOpen,
      reveal: reveal,
      activeKey: function () { return active; }
    };
    band.__qpFrCompare = ctl;
    return ctl;
  }

  function current(doc, win) {
    return init(doc.querySelector('[data-qp-compare]'), win);
  }

  function syncDoors(doc, ctl) {
    list(doc.querySelectorAll('[data-qp-compare-key]')).forEach(function (door) {
      door.hidden = !ctl || !ctl.has(door.getAttribute('data-qp-compare-key'));
    });
    list(doc.querySelectorAll('[data-qp-compare-doors]')).forEach(function (group) {
      group.hidden = !group.querySelector('[data-qp-compare-key]:not([hidden])');
    });
  }

  function hashKey(win) {
    var m = /^#compare-(.+)$/.exec((win && win.location && win.location.hash) || '');
    if (!m) return null;
    try { return decodeURIComponent(m[1]); } catch (err) { return null; }
  }

  function autoInit(doc, win) {
    var ctl = current(doc, win);
    syncDoors(doc, ctl);

    if (doc.__qpFrCompareBound) return ctl;
    doc.__qpFrCompareBound = true;

    var key = hashKey(win);
    if (ctl && key) ctl.reveal(key);

    doc.addEventListener('click', function (e) {
      var door = e.target && e.target.closest && e.target.closest('[data-qp-compare-key]');
      if (!door) return;
      var c = current(doc, win);
      if (c && c.reveal(door.getAttribute('data-qp-compare-key'))) e.preventDefault();
    });

    doc.addEventListener('shopify:section:load', function () {
      syncDoors(doc, current(doc, win));
    });

    doc.addEventListener('shopify:block:select', function (e) {
      var c = current(doc, win), t = e.target;
      if (!c || !t || !t.closest) return;
      var holder = t.closest('[data-qp-compare-tab], [data-qp-compare-panel]');
      if (!holder) return;
      var k = holder.getAttribute('data-qp-compare-tab') || holder.getAttribute('data-qp-compare-panel');
      if (c.select(k)) c.setOpen(true);
    });

    return ctl;
  }

  return { init: init, autoInit: autoInit };
});
